import { usePage } from "PFApp/use_page";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";

export const useCvParsingConfPage = (initPage, accountId) => {
  const { page, setPage, mergePage, resetPage } = usePage(`features`, initPage);

  const getCvParserConfig = () =>
    $.ajax({
      url: ApiRoute(`/api/accounts/${accountId}/cv_parser_config`),
      account_id: accountId,
      api_version: 2
    });

  const putCvParsingConfig = (data) =>
    $.ajax({
      url: ApiRoute(`/api/accounts/${accountId}/cv_parser_config`),
      method: "PUT",
      account_id: accountId,
      api_version: 2,
      data: data
    });

  const getAccount = () =>
    $.ajax({
      url: ApiRoute(`/api/saas_admin/accounts/${accountId}`)
    });

  const getCustomTypes = () =>
    $.ajax({
      url: ApiRoute(`/api/custom_types?account_id=${accountId}`),
      api_version: 2
    });

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    Promise.all([getCvParserConfig(), getAccount(), getCustomTypes()])
      .then((values) =>
        mergePage({
          cvParserConfig: values[0],
          accountName: values[1].name,
          customTypes: values[2].entries,
          loaded: true
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );
  }, []);

  return { ...page, fetch, putCvParsingConfig };
};
